import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import {
  clearSearchTextByPage,
  setSearchTextByPage,
} from "../../redux-store/features/providerFiltersSlice";

const CalendarPageSearch = ({ pageKey = "assessmentCalendar" }) => {
  const dispatch = useDispatch();
  const stored =
    useSelector((state) => state.providersFilters.searchTextByPage[pageKey]) || "";
  const [value, setValue] = useState(stored);

  useEffect(() => {
    setValue(stored);
  }, [stored]);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      if (value.trim()) {
        dispatch(setSearchTextByPage({ pageKey, searchText: value.trim() }));
      } else {
        dispatch(clearSearchTextByPage({ pageKey }));
      }
    }, 300);
    return () => window.clearTimeout(timer);
  }, [value, dispatch, pageKey]);

  return (
    <div className="relative max-w-xl flex-1">
      <label htmlFor="calendar-search" className="sr-only">
        Search
      </label>
      <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
        <MagnifyingGlassIcon aria-hidden="true" className="h-4 w-4 text-gray-400" />
      </div>
      <input
        id="calendar-search"
        name="search"
        type="search"
        placeholder="Search"
        value={value}
        onChange={(event) => setValue(event.target.value)}
        className="block w-full max-w-[300px] rounded-md border-0 py-1.5 pl-9 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-300 sm:text-sm sm:leading-6"
      />
    </div>
  );
};

export default CalendarPageSearch;
